<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_131_7432)">
      <path
        d="M11.6668 1.66667H3.3335V18.3333H16.6668V6.66667L11.6668 1.66667ZM13.3335 15H6.66683V13.3333H13.3335V15ZM13.3335 11.6667H6.66683V10H13.3335V11.6667ZM10.8335 7.5V2.91667L15.4168 7.5H10.8335Z"
        fill="currentColor"
      />
    </g>
  </svg>
</template>
<script lang="ts" setup></script>
